import { FetchMonthlyTourProgram } from "../../../domain/useages/monthly-tour-program/fetchMonthlyTourProgram";
import { HttpConstants } from "../../protocols/http/http-constants";
import { HttpGetClient } from "../../protocols/http/http-get-client";

export class RemoteFetchMonthlyTourProgram implements FetchMonthlyTourProgram {
  constructor(
    private readonly url: string,
    private readonly httpGetClient: HttpGetClient
  ) { }
  
  

  async fetch(
    month: number,
    year: number,
  ): Promise<any> {
    const monthString = month.toString().padStart(2, "0");
    const httpResponse = await this.httpGetClient.get({
      url: this.url
        .replace(":month", monthString)
        .replace(":year", year.toString()),
      headers: {
        [HttpConstants.CONTENT_TYPE]: HttpConstants.APPLICATION_JSON,
        [HttpConstants.ACCEPT]: HttpConstants.APPLICATION_JSON,
         [HttpConstants.APP_ID]: HttpConstants.APP_ID_VALUE,
      },
      authHeaders: true,
    });
    if (httpResponse.status === 200) {
      return httpResponse.data;
    }
  }
}


